<template>
  <div class="contact-us">
    <Retailnavbar> </Retailnavbar>
    <div class="main-page">
      <div class="section-1">Contact Us</div>
      <div class="broker-contact-us">
        <ContactUsComponent></ContactUsComponent>
      </div>
     </div>
    <RetailFooter></RetailFooter>
  </div>
</template>

<script>
import { screenSize } from "../../mixins/ScreenSize.js";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import Retailnavbar from "@/components/RetailSideCompo/RetailNavbar.vue";
import ContactUsComponent from "@/components/RetailSideCompo/ContactUsComponent.vue";

export default {
  name: "BrokersContactUs",

  components: { ContactUsComponent, RetailFooter, Retailnavbar },

  mixins: [screenSize],

  data() {
    return {
    };
  },
  
  mounted() {},
  computed: {},
};
</script>


<style lang="scss" scoped>
.contact-us {
  background-color: #fcfcfb;
  .main-page {
    .section-1 {
      background-image: url("../../assets/images/ExpertLandingPage/footer/broker/banner image.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 400px;
      font-size: 2rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #000;
      text-align: center;
      padding-top: 150px;
    }

    @media screen and (max-width: 876px) {
      .section-1 {
        height: 346px;
        font-size: 1.5rem;
      }
    }

    @media screen and (max-width: 600px) {
      .section-1 {
        height: 200px;
        padding-top: 80px;
        font-size: 1.2rem;
      }
    }
    @media screen and (max-width: 450px) {
      .section-1 {
        height: 134px;
      }
    }
  }
}
</style>

<style lang="scss" >
.broker-contact-us {
  .section-2 {
    .new-feedback-card {
      .left-card {
        background: #3bccdf !important;
        border: 1px solid #3bccdf !important;
      }
      .right-card {
        h1 {
          color: #15a3b6 !important;
        }
        .send-btn {
          border: 1px solid #15a3b6 !important;
          background-color: #15a3b6 !important;
          color: #ffffff !important;
        }
        .el-card {
          box-shadow: 3px 4px 17px 1px #b0dbe1 !important;
          border: 1px solid #ffffff !important;
        }
        .el-input-group__prepend {
          background-color: #f1f1f1 !important;
        }
        .el-input-group__append,
        .el-input-group__prepend {
          border: 2px solid #99eaf5 !important;
          border-right: 0 !important;
        }
        .el-textarea__inner,
        .el-input__inner {
          border: 2px solid #99eaf5 !important;
        }
      }
    }
  }
}
</style>
